import React, { useContext, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import DContext from '../../context/DContext';

import { DARK_LOGO_URL as companyLogo } from '../../config/siteConfig';
import OffcanvasComponent from '../offcanvas/OffCanvasComponent';
import { capitalizeFirstLetter } from '../../helper/stringMethods';

const Header = () => {
  const navigate = useNavigate();

  const { authState, authDispatch, logout } = useContext(DContext);
  const { user, user_role } = authState;


  const handlelogout = () => {
    logout();
    authDispatch({ type: "LOGOUT", payload: "logging out" })
    navigate('/login');
  }

  const toggleSidebar = () => {
    console.log("toggle", document.body.classList.length);
    document.body.classList.toggle('toggle-sidebar');

    console.log('Body classes:', document.body.className);



  }



  const getMenuClassName = () => {
    console.log("get menu class name", document.body.classList.length);
    console.log(window.innerWidth)
    if (document.body.classList.length >= 1 && window.innerWidth <= 900) {
      return "bi bi-x-circle"
    } else {
      return "bi bi-list main-menu"
    }
  }

  const [showCanvase, setShowCanvas] = useState(false);

  const handleToggleCanvas = () => {
    if (showCanvase === true) {
      setShowCanvas(false);
    } else {
      setShowCanvas(true);
    }
  }

return (
    <>
        <header id="header" className="header fixed-top d-flex align-items-center"
            style={{
                background: "white",
                boxShadow: "0 2px 20px rgba(15,37,87,0.08)",
                borderBottom: "1px solid #eef0f8",
                height: "60px",
                padding: "0 16px"
            }}>

            {/* Logo + Toggle */}
            <div className="d-flex align-items-center gap-2" style={{ flexShrink: 0 }}>
                <div className="logo d-flex align-items-center">
                    <Link to="/" className="d-flex align-items-center text-decoration-none">
                        <img src={companyLogo} alt="" style={{ height: "30px", objectFit: "contain" }} />
                    </Link>
                </div>
                <span
                    id="toggle-sidebar-btn"
                    className="hamburger-icon toggle-sidebar-btn"
                    onClick={toggleSidebar}
                    style={{ cursor: "pointer", padding: "6px", borderRadius: "8px" }}
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </span>
            </div>

            {/* Right Nav */}
            <nav className="header-nav ms-auto">
                <ul className="d-flex align-items-center gap-1 mb-0 list-unstyled">

                    {/* Wallet — full pill on desktop, icon-only on mobile */}
                    <li>
                        {/* Desktop */}
                        <Link to='/wallet' className="d-none d-md-flex align-items-center gap-2 text-decoration-none px-3 py-1"
                            style={{
                                background: "linear-gradient(135deg, #ecfdf5, #d1fae5)",
                                border: "1.5px solid #a7f3d0",
                                borderRadius: "20px",
                                fontSize: "13px", fontWeight: "700", color: "#065f46"
                            }}>
                            <i className="bi bi-wallet2" style={{ fontSize: "14px" }}></i>
                            ₹ 2,340.45
                        </Link>

                        {/* Mobile: icon button */}
                        <Link to='/wallet' className="d-flex d-md-none align-items-center justify-content-center text-decoration-none"
                            style={{
                                width: "36px", height: "36px", borderRadius: "10px",
                                background: "#ecfdf5", border: "1.5px solid #a7f3d0",
                                color: "#065f46", flexShrink: 0
                            }}>
                            <i className="bi bi-wallet2" style={{ fontSize: "14px" }}></i>
                        </Link>
                    </li>

                    {/* Notifications */}
                    <li className="nav-item dropdown">
                        <a className="nav-link d-flex align-items-center justify-content-center position-relative"
                            href="#" data-bs-toggle="dropdown"
                            style={{
                                width: "36px", height: "36px", borderRadius: "10px",
                                background: "#f4f6fb", border: "1.5px solid #eef0f8",
                                color: "#374151"
                            }}>
                            <i className="bi bi-bell" style={{ fontSize: "15px" }}></i>
                            <span style={{
                                position: "absolute", top: "6px", right: "6px",
                                width: "7px", height: "7px", borderRadius: "50%",
                                background: "#2d4f8e", border: "2px solid white"
                            }}></span>
                        </a>

                        <ul className="dropdown-menu dropdown-menu-end shadow-sm border-0 mt-2"
                            style={{ borderRadius: "14px", minWidth: "280px", padding: "8px", boxShadow: "0 8px 30px rgba(15,37,87,0.12)" }}>

                            <li className="px-2 py-2 mb-1">
                                <div className="d-flex align-items-center justify-content-between">
                                    <span style={{ fontSize: "13px", fontWeight: "700", color: "#1e3a6e" }}>Notifications</span>
                                    <Link to="/notifications">
                                        <span style={{
                                            background: "#e8edf8", color: "#2d4f8e",
                                            borderRadius: "6px", padding: "2px 10px",
                                            fontSize: "11px", fontWeight: "600"
                                        }}>View all</span>
                                    </Link>
                                </div>
                            </li>

                            {[
                                { icon: "bi-check-circle-fill", iconColor: "#10b981", title: "Congratulation", time: "Just Now" },
                                { icon: "bi-person-circle", iconColor: "#2d4f8e", title: "John Micle", subtitle: "is now following you.", time: "30 min" },
                                { icon: "bi-chat-text-fill", iconColor: "#ef4444", title: "Sneha Jogi", subtitle: "sent you a message.", time: "7 min" },
                            ].map((n, i) => (
                                <li key={i}>
                                    <div className="d-flex align-items-start gap-3 px-2 py-2 rounded-3"
                                        style={{ cursor: "pointer", transition: "background 0.15s" }}
                                        onMouseEnter={e => e.currentTarget.style.background = "#f4f6fb"}
                                        onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                                        <div style={{
                                            width: "32px", height: "32px", borderRadius: "10px",
                                            background: "#f4f6fb", display: "flex", alignItems: "center",
                                            justifyContent: "center", flexShrink: 0
                                        }}>
                                            <i className={`bi ${n.icon}`} style={{ color: n.iconColor, fontSize: "14px" }}></i>
                                        </div>
                                        <div className="flex-grow-1">
                                            <p className="mb-0" style={{ fontSize: "12px", color: "#374151" }}>
                                                <strong>{n.title}</strong>{n.subtitle ? ` ${n.subtitle}` : ""}
                                            </p>
                                            <span style={{ fontSize: "11px", color: "#9ca3af" }}>{n.time}</span>
                                        </div>
                                    </div>
                                </li>
                            ))}

                            <li className="mt-1 pt-1" style={{ borderTop: "1px solid #f0f2f8" }}>
                                <Link to="/notifications" className="d-block text-center text-decoration-none py-2"
                                    style={{ fontSize: "12px", color: "#2d4f8e", fontWeight: "600" }}>
                                    Show all notifications
                                </Link>
                            </li>
                        </ul>
                    </li>

                    {/* Profile */}
                    <li className="nav-item dropdown">
                        <a className="nav-link d-flex align-items-center gap-2 pe-0 text-decoration-none"
                            href="#" data-bs-toggle="dropdown"
                            style={{
                                padding: "4px 6px", borderRadius: "10px",
                                border: "1.5px solid #eef0f8", background: "#f4f6fb"
                            }}>
                            <img
                                src={`https://ui-avatars.com/api/?name=${user?.name}&size=75&background=2d4f8e&color=fff`}
                                alt="Profile" className="rounded-circle"
                                style={{ width: "26px", height: "26px", objectFit: "cover", flexShrink: 0 }}
                            />
                            <span className="d-none d-md-block" style={{ fontSize: "13px", fontWeight: "600", color: "#1e3a6e" }}>
                                {capitalizeFirstLetter(user?.name)}
                            </span>
                            <i className="bi bi-chevron-down d-none d-md-block" style={{ fontSize: "10px", color: "#a0aec0" }}></i>
                        </a>

                        <ul className="dropdown-menu dropdown-menu-end border-0 mt-2"
                            style={{ borderRadius: "14px", minWidth: "200px", padding: "8px", boxShadow: "0 8px 30px rgba(15,37,87,0.12)" }}>

                            <li className="px-2 py-2 mb-1">
                                <div className="d-flex align-items-center gap-2">
                                    <img
                                        src={`https://ui-avatars.com/api/?name=${user?.name}&size=75&background=2d4f8e&color=fff`}
                                        alt="Profile" className="rounded-circle"
                                        style={{ width: "36px", height: "36px", flexShrink: 0 }}
                                    />
                                    <div>
                                        <p className="mb-0" style={{ fontSize: "13px", fontWeight: "700", color: "#1e3a6e" }}>
                                            {capitalizeFirstLetter(user?.name)}
                                        </p>
                                        <div className="d-flex gap-1 mt-1">
                                            <span style={{ fontSize: "10px", fontWeight: "700", background: "#eef0ff", color: "#2d4f8e", borderRadius: "5px", padding: "1px 7px" }}>
                                                {user?.code?.toUpperCase()}
                                            </span>
                                            <span style={{ fontSize: "10px", fontWeight: "700", background: "#eef0ff", color: "#2d4f8e", borderRadius: "5px", padding: "1px 7px" }}>
                                                {user?.role?.role_type?.toUpperCase()}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </li>

                            <li><hr className="dropdown-divider my-1" style={{ borderColor: "#f0f2f8" }} /></li>

                            {[
                                { to: "/profile", icon: "bi-person", label: "My Profile" },
                            ].map((item, i) => (
                                <li key={i}>
                                    <Link to={item.to} className="dropdown-item d-flex align-items-center gap-2 rounded-3"
                                        style={{ fontSize: "13px", color: "#374151", padding: "8px 10px" }}
                                        onMouseEnter={e => e.currentTarget.style.background = "#f4f6fb"}
                                        onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                                        <i className={`bi ${item.icon}`} style={{ color: "#2d4f8e", fontSize: "14px", width: "16px" }}></i>
                                        {item.label}
                                    </Link>
                                </li>
                            ))}

                            <li>
                                <Link to="#" onClick={handleToggleCanvas} className="dropdown-item d-flex align-items-center gap-2 rounded-3"
                                    style={{ fontSize: "13px", color: "#374151", padding: "8px 10px" }}
                                    onMouseEnter={e => e.currentTarget.style.background = "#f4f6fb"}
                                    onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                                    <i className="bi bi-gear" style={{ color: "#2d4f8e", fontSize: "14px", width: "16px" }}></i>
                                    Account Settings
                                </Link>
                            </li>

                            <li>
                                <Link to="/faq" className="dropdown-item d-flex align-items-center gap-2 rounded-3"
                                    style={{ fontSize: "13px", color: "#374151", padding: "8px 10px" }}
                                    onMouseEnter={e => e.currentTarget.style.background = "#f4f6fb"}
                                    onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                                    <i className="bi bi-question-circle" style={{ color: "#2d4f8e", fontSize: "14px", width: "16px" }}></i>
                                    Need Help?
                                </Link>
                            </li>

                            <li><hr className="dropdown-divider my-1" style={{ borderColor: "#f0f2f8" }} /></li>

                            <li>
                                <Link onClick={handlelogout} className="dropdown-item d-flex align-items-center gap-2 rounded-3"
                                    style={{ fontSize: "13px", color: "#e05252", padding: "8px 10px" }}
                                    onMouseEnter={e => e.currentTarget.style.background = "#fdf0f0"}
                                    onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                                    <i className="bi bi-box-arrow-right" style={{ fontSize: "14px", width: "16px" }}></i>
                                    Sign Out
                                </Link>
                            </li>
                        </ul>
                    </li>

                </ul>
            </nav>
        </header>

        <OffcanvasComponent show={showCanvase} toggleCanvas={handleToggleCanvas} />
    </>
)
}

export default Header